import React, { Fragment } from 'react';
import HeaderPortal from 'components/layout/HeaderPortal';
import DictionaryListBrowser from './DictionaryListBrowser';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_DICTIONARIES } from 'constants/rightsCodes';

const Route = () => {
  return (
    <Fragment>
      <HeaderPortal />
      <PermissionCheck authorizationCode={ADMIN_DICTIONARIES}>
        <DictionaryListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

export default Route;
